export const FETCH_BENCHMARKS = '/benchmarks/';
export const FETCH_BENCHMARK = (id: string) => `/benchmarks/${id}`;
export const ADD_BENCHMARK = '/benchmarks/add';
